module.exports = __webpack_public_path__ + "img/eye.66e07f9e.svg";